import * as React from 'react';
import shouldFlipBG from '../utils/should-flip-bg';

interface RadioInputProps {
  name: string;
  labelOnBottom?: boolean;
  id: string;
  label: string;
  description?: React.ReactNode;
  value: string;
  style?: any;
  focus?: boolean;
  required?: boolean;
  checked?: boolean;
  onChange?: Function;
  onBlur?: Function;
  theme?: 'night' | 'day';
  hideRadio?: boolean;
  disabled?: boolean;
}
interface RadioInputState {
  flipBg: string;
}

export default function RadioInput(props: RadioInputProps) {
  const inputEl: any = React.useRef(null);
  const { theme = 'day' } = props;
  const inputElParent: any = React.useRef(null);
  let recursiveCount = 0;
  const getInnerText = (obj: any) => {
    recursiveCount += 1;
    let buf = '';
    if (obj) {
      const type = typeof obj;
      if (type === 'string' || type === 'number') {
        buf += obj;
      } else if (type === 'object') {
        let objchildren = null;
        if (Array.isArray(obj)) {
          objchildren = obj;
        } else {
          const objprops = obj.props;
          if (objprops) {
            objchildren = objprops.children;
          }
        }
        if (objchildren && recursiveCount < 5) {
          if (Array.isArray(objchildren)) {
            objchildren.forEach(function(o) {
              buf += getInnerText(o);
            });
          } else {
            buf += getInnerText(objchildren);
          }
        }
      }
    }
    return buf;
  };
  React.useEffect(() => {
    if (props.focus && inputEl && inputEl.current) {
      inputEl.current.focus();
    }
  }, [props.focus]);

  const handleMouseDown = () => {
    if (inputElParent.current) {
      inputElParent.current.classList.add('using-mouse');
    }
  };

  const handleKeyDown = (e: any) => {
    if (inputElParent.current) {
      if (e.keyCode === 9) {
        inputElParent.current.classList.remove('using-mouse');
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
  }, [props]);

  const [state, setState] = React.useState<RadioInputState>({
    flipBg: ''
  });

  React.useEffect(() => {
    if (state.flipBg === '' && shouldFlipBG(inputElParent, theme)) {
      setState({
        ...state,
        flipBg: ' flipbg'
      });
    }
  }, []);

  return (
    <div
      style={props.style}
      ref={inputElParent}
      className={`input-field ${theme}${state.flipBg}${
        props.disabled ? ' disabled' : ''
      }
      `}
    >
      {!props.hideRadio && (
        <input
          type="radio"
          value={props.value}
          id={props.id}
          className={theme}
          disabled={props.disabled}
          aria-label={`${props.label}${getInnerText(props.description)}`}
          name={props.name}
          ref={inputEl}
          checked={props.checked}
          onBlur={(e: any) => {
            if (props.onBlur !== undefined) {
              props.onBlur(e);
            }
          }}
          onChange={(e: any) => {
            if (props.onChange !== undefined) {
              props.onChange(e);
            }
          }}
        />
      )}
      <div className="text">
        {props.labelOnBottom ? (
          <>
            {props.description && (
              <span className="description">{props.description}</span>
            )}
            {props.label && (
              <label className="value" htmlFor={props.id}>
                {props.label}
              </label>
            )}
          </>
        ) : (
          <>
            {props.label && (
              <label
                className={`value ${props.checked ? 'checked' : ''}`}
                htmlFor={props.id}
              >
                {props.label}
              </label>
            )}
            {props.description && (
              <span className="description">{props.description}</span>
            )}
          </>
        )}
      </div>
      <div className="icon"></div>
    </div>
  );
}
